import Vue from 'vue';
// async components
const ContactForm = () => import('./_partials/ContactForm.vue');
export default Vue.extend({
    name: 'IndexPage',
    components: {
        ContactForm,
    },
    metaInfo: {
        title: 'Akun Pembelajaran | Kemdikbudristek',
        meta: [
            {
                vmid: 'description',
                name: 'description',
                content: 'Akun Pembelajaran merupakan akun elektronik yang diterbitkan oleh Kementerian Pendidikan dan Kebudayaan.',
            },
        ],
    },
    methods: {
        onActiveTabChange(tab) {
            var _a;
            (_a = document.querySelector(`#section${tab}`)) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
                behavior: 'smooth',
            });
        },
    },
});
